/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type FieldTesterLocality =
  (typeof FieldTesterLocality)[keyof typeof FieldTesterLocality];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FieldTesterLocality = {
  Local: 0,
  OtherCounty: 1,
  NoHomeAnchor: 2,
} as const;
